module.exports = __webpack_public_path__ + "media/images/front/programs/icon-next-55e46f4951f29b8f52b9717327dd8cf9.svg";